import {
  fetchSegments,
  fetchSegmentById,
  createSegmentV2,
  filterBySegment,
  selectSegment,
  clearSegmentState,
  deleteSegment,
  updateSegment,
  resetSegmentResult,
  fetchSegmentResultsByIds,
} from '../routines';

const initialState = {
  segmentResult: {
    loading: false,
    data: null,
    error: null,
  },
  createEditSegment: {
    loading: false,
    error: null,
  },
  segmentList: [],
  segmentError: null,
  segmentLoading: true,
  segmentById: null,
  segmentByIdError: null,
  segmentByIdLoading: true,
  selectedSegment: null,
  selectedSegmentError: null,
  selectedSegmentLoading: false,
  selectedSegmentsResults: {
    loading: false,
    data: [],
    error: null,
  },
};

const segmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case clearSegmentState.TRIGGER: {
      return {
        ...initialState,
        segmentList: state.segmentList,
      };
    }
    case resetSegmentResult.TRIGGER: {
      return {
        ...state,
        segmentResult: {
          loading: false,
          data: null,
          error: null,
        },
      };
    }
    case fetchSegments.TRIGGER: {
      return {
        ...state,
        segmentError: null,
        segmentLoading: true,
      };
    }
    case fetchSegmentResultsByIds.TRIGGER: {
      return {
        ...state,
        selectedSegmentsResults: {
          loading: true,
          data: [],
          error: null,
        },
      };
    }
    case fetchSegmentResultsByIds.SUCCESS: {
      return {
        ...state,
        selectedSegmentsResults: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    }
    case fetchSegmentResultsByIds.FAILURE: {
      return {
        ...state,
        selectedSegmentsResults: {
          loading: false,
          data: [],
          error: action.payload.error,
        },
      };
    }
    case deleteSegment.SUCCESS: {
      return {
        ...state,
        segmentLoading: false,
        selectedSegment: null,
      };
    }
    case deleteSegment.TRIGGER: {
      return {
        ...state,
        segmentLoading: false,
      };
    }
    case selectSegment.TRIGGER: {
      return {
        ...state,
        selectedSegment: { ...action.payload },
        selectedSegmentError: null,
        selectedSegmentLoading: false,
        segmentResult: { ...state.segmentResult, data: null, error: null },
      };
    }
    case fetchSegments.FAILURE: {
      return {
        ...state,
        segmentError: action.error,
        segmentLoading: false,
      };
    }
    case fetchSegments.SUCCESS: {
      return {
        ...state,
        segmentList: action.payload,
        segmentError: null,
        segmentLoading: false,
      };
    }
    case fetchSegmentById.TRIGGER: {
      return {
        ...state,
        segmentById: null,
        segmentByIdError: null,
        segmentByIdLoading: true,
      };
    }
    case fetchSegmentById.SUCCESS: {
      return {
        ...state,
        segmentById: action.payload,
        segmentByIdError: null,
        segmentByIdLoading: false,
      };
    }
    case fetchSegmentById.FAILURE: {
      return {
        ...state,
        segmentById: null,
        segmentByIdError: action.payload.error,
        segmentByIdLoading: false,
      };
    }
    case updateSegment.TRIGGER:
    case createSegmentV2.TRIGGER: {
      return {
        ...state,
        createEditSegment: {
          ...state.createEditSegment,
          loading: true,
          error: null,
        },
      };
    }
    case updateSegment.FAILURE:
    case createSegmentV2.FAILURE: {
      return {
        ...state,
        createEditSegment: {
          ...state.createEditSegment,
          loading: false,
          error: action.payload.error,
        },
      };
    }
    case updateSegment.SUCCESS:
    case createSegmentV2.SUCCESS: {
      return {
        ...state,
        createEditSegment: {
          ...state.createEditSegment,
          loading: false,
          error: null,
        },
      };
    }
    case filterBySegment.TRIGGER: {
      return {
        ...state,
        segmentResult: { ...state.segmentResult, loading: true },
      };
    }
    case filterBySegment.FAILURE: {
      return {
        ...state,
        segmentResult: { ...state.segmentResult, loading: false },
      };
    }
    case filterBySegment.SUCCESS: {
      return {
        ...state,
        segmentResult: {
          ...state.segmentResult,
          loading: false,
          data: action.payload,
        },
      };
    }
    default:
      return state;
  }
};

export default segmentReducer;
